<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.elevator_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/v4ward/elevator/elevator";
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    labelWidth: 120,
                    tip: false,
                    searchShow: true,
                    searchMenuSpan: 6,
                    border: true,
                    index: false,
                    viewBtn: true,
                    selection: true,
                    dialogClickModal: false,
                    column: [
                                                                                    {
                                    label: "ID",
                                    prop: "id",
                                    editDisplay: false,
                                    addDisplay: false,
                                    viewDisplay: false,
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入主键ID",
                                        trigger: "change"
                                    }]
                                },
                                   {
                                    label: "小区名称",
                                    prop: 'communityId',
                                    type: 'select',
                                    dicUrl: 'api/base/property/getCommunityTree',
                                    props: { label: 'roomName', value: 'id' },
                                    search: true,
                                    maxlength: 100,
                                    rules: [{
                                        required: true,
                                        message: "请输入小区名称",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "楼栋名称",
                                    prop: "buildingName",
                                    maxlength: 100,
                                    rules: [{
                                        required: true,
                                        message: "请输入楼栋名称",
                                        trigger: "change"
                                    }]
                                },
                                {
                                  label: "电梯名称",
                                  prop: "name",
                                  maxlength: 100,
                                  rules: [{
                                    required: true,
                                    message: "请输入电梯名称",
                                    trigger: "change"
                                  }]
                                },
                                {
                                  label: "使用地址",
                                  prop: "address",
                                  maxlength: 255,
                                  hide: true,
                                  rules: [{
                                    required: true,
                                    message: "请输入地址",
                                    trigger: "change"
                                  }]
                                },
                                {
                                  label: "电梯品牌",
                                  prop: "brand",
                                  maxlength: 100,
                                  rules: [{
                                    required: true,
                                    message: "请输入品牌",
                                    trigger: "change"
                                  }]
                                },
                                {
                                  label: "电梯厂商",
                                  prop: "vendor",
                                  hide: true,
                                  maxlength: 100,
                                  rules: [{
                                    required: true,
                                    message: "请输入厂商",
                                    trigger: "change"
                                  }]
                                },
                                {
                                  label: "电梯型号",
                                  prop: "model",
                                  maxlength: 64,
                                  rules: [{
                                    required: true,
                                    message: "请输入电梯型号",
                                    trigger: "change"
                                  }]
                                },
                                {
                                    label: "电梯编号",
                                    prop: "code",
                                    search: true,
                                    maxlength: 64,
                                    rules: [{
                                        required: true,
                                        message: "请输入电梯编号",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "安全负责人",
                                    prop: "safetyOfficer",
                                    hide: true,
                                    maxlength: 40,
                                    rules: [{
                                        required: true,
                                        message: "请输入安全员",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "联系电话",
                                    prop: "linkPhone",
                                    maxlength: 20,
                                    rules: [{
                                        required: true,
                                        message: "请输入联系电话",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "维保单位",
                                    prop: "upkeepOrgan",
                                    hide: true,
                                    maxlength: 100,
                                    rules: [{
                                        required: true,
                                        message: "请输入维保单位",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "维保负责人",
                                    prop: "upkeepMan",
                                    hide: true,
                                    maxlength: 40,
                                    rules: [{
                                        required: true,
                                        message: "请输入维保负责人",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "备注",
                                    prop: "remark",
                                    maxlength: 500,
                                    editDisplay: false,
                                    addDisplay: false,
                                    viewDisplay: false,
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入备注",
                                        trigger: "change"
                                    }]
                                },
                                                                        ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.elevator_add, false),
                    viewBtn: this.vaildData(this.permission.elevator_view, false),
                    delBtn: this.vaildData(this.permission.elevator_delete, false),
                    editBtn: this.vaildData(this.permission.elevator_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
              //小区没选默认查0条
              if (this.query.communityId===''||this.query.communityId===undefined) {
                this.query.communityId=-1;
              }

                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
